import React, {useEffect, useState} from "react";
import DialogTitle from "@mui/material/DialogTitle";
import {Container, TextField} from "@mui/material";
import PercentageForm from "./FormDomande/PercentageForm";
import QuizForm from "./FormDomande/QuizForm";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {firestore} from "../firebase/clientApp";

export default function EditEvent({open, handleSetOpen,event}){
    const [title, setTitle] = useState('')

    useEffect(()=>{
        setTitle(event.title)
    },[event])

    function handleSetTitle(event) {
        setTitle(event.target.value)
    }

    function handleEdit() {
        firestore.collection('users/plesh/events/').doc(event.id)
            .set({title:title}, {merge: true})
            .then(r => handleSetOpen())
    }

    return(
        <Dialog open={open} onClose={handleSetOpen} fullWidth>
            <DialogTitle>Edit event</DialogTitle>
            <Container>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Question"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={title}
                    onChange={handleSetTitle}
                />
                <DialogActions>
                    <Button onClick={handleSetOpen}>Cancel</Button>
                    <Button onClick={handleEdit}>Save</Button>
                </DialogActions>
            </Container>
        </Dialog>
    )
}